/**
 * src/hooks/useConvenios.js
 * Los Convenios Marco soportados, servidos por el backend (app/convenios.py).
 *
 * Existía la misma función copiada en `Onboarding.jsx` y en `Clientes.jsx`, y
 * la tercera copia iba a nacer con la tarjeta de tiendas del tenant. Es el §4
 * de docs/ERRORES_RECURRENTES.md: una regla decidida en varios sitios. Aquí
 * vive una sola vez y cada pantalla la adapta a lo que necesite.
 */
import { useEffect, useState } from 'react'
import { getConvenios } from '../api/convenios'

export function useConvenios() {
  const [convenios, setConvenios] = useState([])
  useEffect(() => {
    getConvenios()
      .then(cs => setConvenios(Array.isArray(cs) ? cs : []))
      .catch(() => setConvenios([]))
  }, [])
  return convenios
}

/** Slug de tienda → nombre legible. `aseo3` sin más no le dice nada a nadie. */
export function useNombreDeTienda() {
  const convenios = useConvenios()
  const porSlug = Object.fromEntries(convenios.map(c => [c.slug, c.nombre]))
  return slug => porSlug[slug] || null
}
